<template>
    <div ref="logHistory">
        <app-datatable :type="'view'" :elements="dtElementsDetail" :collections="logData"></app-datatable>
    </div>
</template>

<script>
import api from '../services/api'
import AppDatatable from './AppDatatable'
import {logData} from '../models/log'

export default {
    components: {
        AppDatatable
    },
    props: ['id', 'module'],
    data() {
        return {
            logData: {...logData},
            dtElementsDetail: [
                {
                    title: 'Action',
                    column: 'action',
                    type: 'text',
                    width: 2,
                },
                {
                    title: 'Remark',
                    column: 'remark',
                    type: 'text',
                    width: 3,
                },
                {
                    title: 'Issued By',
                    column: 'createdByName',
                    type: 'text',
                    width: 3,
                },
                {
                    title: 'Status',
                    column: 'statusName',
                    type: 'text',
                    width: 2,
                },
                {
                    title: 'Issued Date',
                    column: 'issuedDate',
                    type: 'text',
                    width: 2,
                },
                {
                    title: 'Issued Time',
                    column: 'issuedTime',
                    type: 'text',
                    width: 1,
                },
            ],
        }
    },
    async created() {
        const logApi = api('log/history')
        const query = {
            params: {
                id: this.id,
                module: this.module,
            }
        }
        this.logData = await logApi.getWithQuery(query)
    },
    methods: {
        async loadHistoryData(query) {
            const logApi = api('log/history')
            this.logData = await logApi.getWithQuery(query)
        },
    }
}
</script>